<template>
  <div class="fixed inset-0 bg-primary-500 z-50 p-8 overflow-y-auto">
    <div v-if="loading">
      <loading />
    </div>
    <div v-else>
      <div class="text-right">
        <wd-button transparent @input="removeCelebration">
          <icon name="Close" />
        </wd-button>
      </div>
      <div class="w-full text-center mt-8">
        <div class="mb-4">
          <icon name="WaldigLogo" size="5em" :settings="{ circle: true }" />
        </div>
        <h1>{{ $t("general.congratulations") }}!</h1>
      </div>
      <div
        class="relative p-2 mb-6 mx-auto bg-black w-full max-w-lg overflow-hidden border-2 border-black rounded-xl"
        v-if="giphy"
      >
        <img
          class="w-full h-full object-contain"
          :src="giphy.image_original_url"
        />
        <div class="grid grid-cols-2 gap-2 items-center mt-2">
          <div class="text-xs font-medium text-gray-600 tracking-wider hover:text-gray-400 ml-2 transition-colors duration-150"><a :href="giphy.user.profile_url">@{{giphy.username}}</a></div>
          <div class="ml-auto">
            <img
              class="w-40"
              style="mix-blend-mode: lighten"
              src="/images/logos/PoweredBy_640_Horizontal_Light-Backgrounds_With_Logo.gif"
            />
          </div>
        </div>
      </div>
      <div class="text-center">
        <div
          class="tracking-wide text-lg max-w-sm mx-auto"
          v-if="celebration.type === 'target'"
        >
          <h2>{{ $t("targets.target_finished_title") }}</h2>
          <p>{{ celebration.text }}</p>
        </div>
        <div
          class="tracking-wide text-lg max-w-sm mx-auto"
          v-if="celebration.type === 'allCategories'"
        >
          {{ $t("actions.you_finished_all_categories") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Celebration",
  data() {
    return {
      giphy: null,
    };
  },
  props: {
    celebration: {
      type: Object,
    },
  },
  components: {},
  methods: {
    removeCelebration() {
      this.$store.dispatch(
        "notification/removeCelebration",
        this.celebration.id
      );
    },
  },
  computed: {},
  async created() {
    this.giphy = await this.$store.getters["notification/api"].Custom.Gif();
    this.loaded();
  },
};
</script>
